import { News } from '@/types/news';

const sampleBannerImages = [
    'https://best-bike.s3.ap-southeast-1.amazonaws.com/customers/1734487333540.jpg',
    'https://best-bike.s3.ap-southeast-1.amazonaws.com/customers/1734487333540.jpg',
    'https://best-bike.s3.ap-southeast-1.amazonaws.com/customers/1734487333540.jpg'
];

const advertisementUrl = 'https://best-bike.s3.ap-southeast-1.amazonaws.com/customers/1733908744540.png';

const imageThumnail = 'https://best-bike.s3.ap-southeast-1.amazonaws.com/customers/1733908744540.png';

const dummyNews: News[] = [
    {
        id: 1,
        title: 'Breaking News: TypeScript 5.0 Released!',
        createdAt: '2024-12-01T08:30:00Z',
        attachEntry: imageThumnail
    },
    {
        id: 2,
        title: 'Top 10 JavaScript Frameworks in 2024',
        createdAt: '2024-11-28T14:45:00Z',
        attachEntry: imageThumnail
    },
    {
        id: 3,
        title: 'AI Tools Revolutionizing Software Development',
        createdAt: '2024-11-25T10:00:00Z',
        attachEntry: imageThumnail
    },
    {
        id: 4,
        title: 'Holiday Season Tech Deals You Can\'t Miss',
        createdAt: '2024-11-22T16:15:00Z',
        attachEntry: imageThumnail
    },
    {
        id: 5,
        title: 'Understanding Web Performance Optimization',
        createdAt: '2024-11-20T09:00:00Z',
        attachEntry: imageThumnail
    }
];

export { dummyNews, advertisementUrl, sampleBannerImages };
